import { Image } from '@src/@data/types/common';
import { CalendarType } from '@src/@data/types/calendars';
import { CompanyClientGroup } from '@src/@data/types/clientGroups';

export enum ReservationStatus {
  Pending = 'pending',
  PendingPayment = 'pendingPayment',
  Confirmed = 'confirmed',
  Rejected = 'rejected',
  Cancelled = 'cancelled',
  FailedPayment = 'failedPayment',
  AwaitingPayment = 'awaitingPayment',
  Finished = 'finished',
  Missed = 'missed',
  Reviewed = 'reviewed',
  Paid = 'paid',
}

export interface ClientReservation {
  id: string;
  deepLink: string;
  type: CalendarType;
  slotId?: string;
  startDate: string;
  endDate: string;
  requestedAt: string;
  timeZone: string;
  serviceTitle: string;
  calendarTitle: string;
  isBooklaUser: boolean;
  status: ReservationStatus;
  shared: boolean;
}

export interface CompanyClientId {
  id: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  countryIsoCode?: string;
  email?: string;
  isGuest?: boolean;
}

export interface CompanyClient extends CompanyClientId {
  deepLink: string;
  isBooklaUser: boolean;
  thumbnail?: string;
  deletedAt?: string;
  lastVisitDate?: string;
  blocked: boolean;
}

export interface CompanyClientWithData extends CompanyClientId {
  isBooklaUser: boolean;
  autosyncEnabled?: boolean;
  deleted?: boolean;
  image?: Image;
  birthday?: string;
  comment: string;
  lastVisitDate: string;
  deepLink: string;
  block?: {
    blockedAt: string;
    reason: string;
  };
  clientGroups: CompanyClientGroup[];
}

export interface CompanyClientWithReservations extends CompanyClientWithData {
  reservations?: ClientReservation[];
  reservationsDeepLink?: string;
  block?: {
    blockedAt: string;
    reason: string;
  };
}

export interface CompanyClientsSelection {
  totalCount: number;
  clients: CompanyClient[];
}

export enum ClientsSelectionSortBy {
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  PhoneNumber = 'phoneNumber',
  LastVisitDate = 'lastVisitDate',
}

export interface CreateCompanyClient {
  birthday?: string;
  comment?: string;
  countryIsoCode?: string;
  phoneNumber?: string;
  email?: string;
  firstName: string;
  lastName?: string;
  clientGroups: string[];
}

export interface ImportedClient {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
}

export interface ImportClientsResponse {
  conflicting: number[];
  invalid: number[];
  created: number;
}
